import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDocument = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6 1.25A2.75 2.75 0 0 0 3.25 4v16A2.75 2.75 0 0 0 6 22.75h12A2.75 2.75 0 0 0 20.75 20V9a.75.75 0 0 0-.22-.53l-7-7a.75.75 0 0 0-.53-.22m-.75 1.5H6A1.25 1.25 0 0 0 4.75 4v16A1.25 1.25 0 0 0 6 21.25h12A1.25 1.25 0 0 0 19.25 20V9.75H13a.75.75 0 0 1-.75-.75zm5.94 5.5-4.44-4.44v4.44z",
		clipRule: "evenodd"
	})
});
export default SvgDocument;
